__webpack_require__.p = "/rex/";